import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { getThemeSelector } from '@src/store/selectors';
import { isPrivatePageNeedLogin, clearQueryString } from '@src/utils/common';

const useCheckCloseWebPrivatePage = (): boolean => {
	const router = useRouter();
	const { pages, themes: { closed_web: closedWeb } } = useSelector(getThemeSelector) as any;
	let path = router.asPath;
	if (path.indexOf('/category/') === 0) path = '/category/all';
	const themePage = _.find(pages, {
		allPath: clearQueryString(path),
	});
	const isPrivatePage = _.get(themePage, 'content.isPrivatePage', closedWeb);
	return isPrivatePageNeedLogin({ isPrivatePage, closedWeb });
};

export default useCheckCloseWebPrivatePage;
